// extracted by css-extract-rspack-plugin
export default {"symbol":"QBrKs"};